/**
 * Browser stub for the `jiti` dynamic import helper. The real implementation relies on
 * Node internals, so in the playground runtime we provide a no-op that throws if used.
 */

export type JitiStub = (...args: unknown[]) => never;

const createJitiStub = (): JitiStub => {
  return () => {
    throw new Error('jiti is not available in the browser playground runtime');
  };
};

export default function jiti(): JitiStub {
  return createJitiStub();
}
